import React from 'react';
import SearchableSelect from './SearchableSelect';

const DataTablePagination = ({
  currentPage = 1,
  pageSize = 10,
  totalItems = 0,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50],
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safeCurrentPage = Math.min(Math.max(1, currentPage), totalPages);

  const startRecord = totalItems === 0 ? 0 : (safeCurrentPage - 1) * pageSize + 1;
  const endRecord = Math.min(safeCurrentPage * pageSize, totalItems);

  const handlePrev = () => {
    if (safeCurrentPage > 1) {
      onPageChange(safeCurrentPage - 1);
    }
  };

  const handleNext = () => {
    if (safeCurrentPage < totalPages) {
      onPageChange(safeCurrentPage + 1);
    }
  };

  // Generate page numbers to show (e.g. up to 5 buttons centered on current page)
  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, safeCurrentPage - 2);
    let end = Math.min(totalPages, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="dt-pagination-bar" aria-label="Table pagination">
      <div className="dt-pagination-info">
        <span className="dt-page-size-label">Rows per page:</span>
        <SearchableSelect
          className="dt-page-size-select-wrap"
          triggerClassName="dt-page-size-select"
          value={String(pageSize)}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          options={pageSizeOptions.map((opt) => ({
            value: String(opt),
            label: String(opt),
          }))}
          aria-label="Select rows per page"
        />
        <span className="dt-showing-count">
          Showing <strong>{startRecord}</strong>–<strong>{endRecord}</strong> of{' '}
          <strong>{totalItems}</strong> records
        </span>
      </div>

      <div className="dt-pagination-nav">
        <button
          type="button"
          className="dt-page-btn dt-prev-btn"
          onClick={handlePrev}
          disabled={safeCurrentPage <= 1}
          aria-label="Previous page"
        >
          <i className="fas fa-chevron-left" /> Prev
        </button>

        <div className="dt-page-numbers">
          {getPageNumbers().map((p) => (
            <button
              key={p}
              type="button"
              className={`dt-page-num-btn ${p === safeCurrentPage ? 'active' : ''}`}
              onClick={() => onPageChange(p)}
              aria-label={`Page ${p}`}
              aria-current={p === safeCurrentPage ? 'page' : undefined}
            >
              {p}
            </button>
          ))}
        </div>

        <button
          type="button"
          className="dt-page-btn dt-next-btn"
          onClick={handleNext}
          disabled={safeCurrentPage >= totalPages}
          aria-label="Next page"
        >
          Next <i className="fas fa-chevron-right" />
        </button>
      </div>
    </div>
  );
};

export default DataTablePagination;
